import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VCard,
    { staticClass: "pa-4", attrs: { flat: "", outlined: "" } },
    [
      _c(
        VCard,
        { attrs: { flat: "" } },
        [
          _c(VCardTitle, { staticClass: "subtitle-1 pa-0 ma-0" }, [
            _c("span", [
              _vm._v(
                "Unidades (" +
                  _vm._s(_vm.value.unidades.length) +
                  " selecionada(s))"
              ),
            ]),
          ]),
          _c(
            VCardText,
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.value.habilitado,
                  expression: "value.habilitado",
                },
              ],
              staticClass: "pa-0 ma-0",
            },
            [
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    { attrs: { cols: "12" } },
                    [
                      _c("app-treeview", {
                        key: _vm.value.macro,
                        attrs: {
                          value: _vm.treeview,
                          nos: _vm.unidadesMacro,
                          lista: _vm.unidades,
                        },
                        on: { return: (value) => _vm.sincronize(value) },
                        scopedSlots: _vm._u([
                          {
                            key: "toolbar",
                            fn: function () {
                              return [
                                _vm.value.categoria
                                  ? _c(VSelect, {
                                      staticClass: "ml-4",
                                      attrs: {
                                        items: _vm.categorias,
                                        "item-text": "descricao",
                                        "item-value": "id",
                                        label: "Categoria",
                                        dense: "",
                                      },
                                      model: {
                                        value: _vm.value.categoria,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.value, "categoria", $$v)
                                        },
                                        expression: "value.categoria",
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }